document.addEventListener("DOMContentLoaded", () => {
    const open_popup_buttons = document.querySelectorAll('.levit-open-popup-button'),
          close_popup_buttons = document.querySelectorAll('.levit-close-popup-button');
    open_popup_buttons.forEach((open_button) => {
        open_button.addEventListener('click', (e) => {
            let popup_id = e.target.dataset.popup,
                popup_container = document.getElementById(`levit-popup-${popup_id}`);

            popup_container.classList.add('toggled');
            popup_container.querySelectorAll('.levit-close-popup-button').forEach((c) => {
                c.setAttribute('data-popup', popup_id);
            });
        });
    });

    close_popup_buttons.forEach((close_button) => {
        close_button.addEventListener('click', (e) => {
            let popup = e.target.dataset.popup;
            document.getElementById(`levit-popup-${popup}`).classList.remove('toggled');
        });
    });

    document.addEventListener( 'click', (e) => {
        if(e.target.matches('.levit-popup-container.toggled')) {
            e.target.classList.remove('toggled')
        }
    });
});
